export const validatePreventBlankString = () => (input: string) => {
  // will return false if string only has spaces like '   '
  return !!input.trim().length
}
